import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'searchFilter' })
export class SearchFilter implements PipeTransform {
  transform(value: any[],filter:string) {
    if(!value) return null;
    if(!filter) return value;
    if(filter && filter.length>0){
        filter = filter.trim();
        filter = filter.toLowerCase();
    }
    if(filter && filter.length == 0){
        return value;
    }
    
    return value.filter(function(item){
        return JSON.stringify(item).toLowerCase().includes(filter);
    });
  }
}